import React, { useState, useEffect }from "react";
import "./Factorio.css";
import "./public.css";
import 'bootstrap/dist/css/bootstrap.css';

export const Factorio = () => {
  const [packageDetails, setPackageDetails] = useState([]);
  useEffect(() => {
    fetch('/factorio.json')
      .then(res => res.json())
      .then(data => setPackageDetails(data))
      .catch(error => console.error(error));
  }, []);
  return (
    <div className="info">
      <br></br>
      <h1>Factorio</h1>
      <div className="d-flex row justify-content-center">
        {packageDetails.map(packageDetail => (
          <div class={`packagebox ${packageDetail.id}`}>
            <h2>{packageDetail.name}</h2>
            <p>{packageDetail.slots} Player Slots</p>
            <p>{packageDetail.memory/1024} GB RAM</p>
            <p>{packageDetail.cpu/100} {packageDetail.cpu/100 === 1 ? 'vCore' : 'vCores'}</p>
            <p>DDoS Protection</p>
            <p>Pterodactyl Panel</p>
            <p>Starting At ${Number(packageDetail.price).toFixed(2).replace(/\.?0+$/,"")}</p>
            <a href={`${packageDetail.link}`}>Order Now</a>
        </div>
        ))}
      </div>
    </div>
  );
};